import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";

const NotFound = () => {
  return (
    <Container fluid className="mt-5">
      <Row>
        <Col>
          <h2 className="text-muted mb-4">Iskana stran ni bila najdena</h2>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
